import React from 'react';
import { FlatList } from 'react-native-gesture-handler';
import {
  FlatListProps,
  ScrollViewProps,
  StyleProp,
  ViewStyle,
} from 'react-native';
import { SCREEN_PADDING } from '@/styles';

export const DRAG_HANDLE_MARGIN = 20;
export const DRAG_HANDLE_WIDTH = 24;
export const DEFAULT_LIST_ITEM_HORIZONTAL_PADDING = SCREEN_PADDING;

export interface Props<T> {
  automaticallyAdjustContentInsets?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
  contentInsetAdjustmentBehavior?: FlatListProps<T>['contentInsetAdjustmentBehavior'];
  disabled?: boolean;
  dragHandleSide?: 'left' | 'right';
  isDragHidden?: boolean;
  itemHeight?: number;
  items: T[];
  ItemSeparatorComponent?: React.ComponentType<{}>;
  ListFooterComponent?: React.ComponentType<{}>;
  ListHeaderComponent?: React.ComponentType<{}>;
  listItemHorizontalPadding?: number;
  listItemStyle?: StyleProp<ViewStyle>;
  listRef?: React.ForwardedRef<FlatList<T>>;
  onChange: (items: T[]) => void;
  renderInPortal?: boolean;
  renderItemContent: (item: T, index?: number) => React.ReactNode;
  scrollViewProps?: ScrollViewProps;
  stickyHeaderIndices?: number[];
}
